// Clears legacy v3 "appSession" cookies that persist after v3 → v4 upgrade (SDK only clears __session).
const LEGACY_SESSION_COOKIE_NAME = "appSession";
const MAX_LEGACY_CHUNKS = 10;
// Generate Set-Cookie headers to expire legacy v3 appSession cookies (base + chunked .0-.9).
export function clearLegacySessionCookies(maxChunks = MAX_LEGACY_CHUNKS) {
    const result = [];
    result.push(`${LEGACY_SESSION_COOKIE_NAME}=; Path=/; Max-Age=0`);
    for (let i = 0; i < maxChunks; i++) {
        result.push(`${LEGACY_SESSION_COOKIE_NAME}.${i}=; Path=/; Max-Age=0`);
    }
    return result;
}
